export * from 'server/models/Bill';


// WEBPACK FOOTER //
// ./data/models/Bill.ts